import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { imageFromSvg } from "@universityofmaryland/web-utilities-library/media";
import { createMediaQuery } from "@universityofmaryland/web-utilities-library/styles";
import { person } from "@universityofmaryland/web-icons-library/people";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../atomic/assets/image/background.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/person/columns.js";
import { createTextLockupContact } from "../../atomic/text-lockup/contact.js";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import { createTextLockupPerson } from "../../atomic/text-lockup/person.js";
import "../../atomic/text-lockup/small.js";
const mediumBreakpointStart = token.media.breakpointValues.medium.min;
const CreatePersonBlockElement = (props) => {
  const { image: personImage, isThemeDark } = props;
  const textLockupElement = createTextLockupPerson({
    ...props
  });
  const contactLockupElement = createTextLockupContact(props);
  let image = personImage;
  if (!image) {
    image = imageFromSvg({
      SVG: person
    });
  }
  const imageContainer = new ElementBuilder().withClassName("person-block-image").withChild(
    createImageBackground({
      element: image,
      isScaled: false,
      imageLoading: "lazy",
      customStyles: {
        height: "auto"
      }
    })
  ).withStyles({
    element: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: `${token.color.gray.lighter}`,
      marginBottom: `${token.spacing.md}`,
      ...isThemeDark && {
        backgroundColor: `${token.color.gray.darker}`
      },
      ["& img, & svg"]: {
        display: "block",
        width: "100%",
        objectFit: "contain",
        height: "140px !important",
        transform: `none !important`,
        ...createMediaQuery("min-width", mediumBreakpointStart, {
          height: "200px !important"
        })
      }
    }
  }).build();
  return new ElementBuilder().withClassName("person-block").withChildren(imageContainer, textLockupElement, contactLockupElement).build();
};
const createCompositePersonBlock = CreatePersonBlockElement;
export {
  createCompositePersonBlock
};
//# sourceMappingURL=block.js.map
